export const substituteTeacherI18n = {
  en: {
    substituteTeachers: 'Substitute Teachers Admin',
    givenIntivations: 'Given Invitations',
    receivedIntivations: 'Received Invitations',
    invite: 'Invite',
    canEdit: 'Can Edit',
    canGrade: 'Can Grade', 
    acceptInvitation: 'Accept Invitation',
    rejectInvitation: 'Reject Invitation',
    updateInvitation: 'Update Invitation',
    pendingInvitations: 'Pending Invitations',
    headers: {
      teacherName: 'Teacher Name',
      from: 'From',
      to: 'To',
      email: 'Email',
      classes: 'Classes',
      status: 'Status',
      actions: 'Actions'
    },
    status: {
      approved: 'Approved',
      pending: 'Pending',
      invited: 'Invited', 
      accepted: 'Accepted', 
      rejected: 'Rejected',
      revoked: 'Revoked', 
      granted: 'Granted'
    },
    info: {
      rejectInvitationConfirm: 'Are you sure you want to reject this invitation?',
      deleteInvitationConfirm: 'Are you sure you want to remove this invitation?',
      overlapInvitation: 'The substitute teacher has another invitation that overlap with this one for the same class/classes',
      overlapInvitationTitle: 'Overlap Invitations',
      forbiddenAction: 'Forbidden Action',
      sameEmail: 'You cannot sand an invitation to the same email you are logged in with.',
      pendingInvitations: 'You have pending invitations to be a Substitute Teacher.  You can respond them clicking on the \'Go\' button.',
      belongsOtherInstitution: 'The substitute teacher is already associated to another institution',
      hasClassesAssigned: 'The substitute teacher is already assigned to the following classes: {classes}.  Deselect them in order to send the invitation.',

    },
    success: {
      teacherInvited: 'The invitation was sent successfully',
      invitationAccepted: 'The invitation was approved successfully',
      invitationDeleted: 'The invitation was deleted successfully',
      invitationRejected: 'The invitation was rejected successfully',
      invitationUpdated: 'The invitation was updated successfully'
    },
    errors: {
      noAvailableClasses: 'There are no classes available for teacher substitution',
      teacherNoInvited: 'There was an error trying to send the invitation',
      invitationNoAccepted: 'The invitation could not be approved. Try again.',
      invitationNoDeleted: 'The invitation could not be deleted. Try again.',
      invitationNoRejected: 'The invitation could not be rejected. Try again.',
      invitationNoUpdated: 'The invitation could not be updated. Try again.'
    }
  },
  es: {
    substituteTeachers: 'Administrador de profesores sustitutos',
    givenIntivations: 'Invitaciones enviadas',
    receivedIntivations: 'Invitaciones recibidas',
    invite: 'Invitar',
    canEdit: 'Puede editar',
    canGrade: 'Puede calificar', 
    acceptInvitation: 'Aceptar invitación',
    rejectInvitation: 'Rechazar invitación',
    updateInvitation: 'Actualizar invitación',
    pendingInvitations: 'Invitaciones Pendientes',
    headers: {
      teacherName: 'Nombre del profesor',
      from: 'Desde',
      to: 'Hasta',
      email: 'Correo',
      classes: 'Clases',
      status: 'Estatus',
      actions: 'Acciones'
    },
    info: {
      rejectInvitationConfirm: 'Está seguro de que desea rechazar esta invitación?',
      deleteInvitationConfirm: 'Está seguro de que desea eliminar esta invitación?',
      overlapInvitation: 'El profesor sustituto tiene otra invitación que se sobrepone con esta para la(s) misma(s) clase(s).',
      overlapInvitationTitle: 'Invitaciones sobrepuestas',
      forbiddenAction: 'Acción prohibida',
      sameEmail: 'No puede enviar una invitación al mismo correo con el que está autenticado.',
      pendingInvitations: 'Tiene invitaciones pendientes para ser Profesor Sustituto.  Puede responderlas haciendo click en el botón \'Ir\'',
      belongsOtherInstitution: 'El profesor sustituto ya está asociado a otra institución',
      hasClassesAssigned: 'El profesor sustituto ya está asignado a las siguentes clases: {classes}. Deselecciónelos para enviar la invitación.',
    },
    status: {
      approved: 'Aprobado',
      pending: 'Pendiente',
      invited: 'Invitado', 
      accepted: 'Aceptado', 
      rejected: 'Rechazado',
      revoked: 'Revocado', 
      granted: 'Otorgado'
    },
    success: {
      teacherInvited: 'La invitación fue enviada con éxito',
      invitationAccepted: 'La invitación fue aprobada con éxito',
      invitationDeleted: 'La invitación fue eliminada con éxito',
      invitationRejected: 'La invitación fue rechazada con éxito',
      invitationUpdated: 'La invitación fue actualizada con éxito'
    },
    errors: {
      noAvailableClasses: 'No hay clases disponibles para invitar profesores sustitutos',
      teacherNoInvited: 'Hubo un error enviando la invitación',
      invitationNoAccepted: 'La invitación no pudo ser aceptada. Intente nuevamente',
      invitationNoDeleted: 'La invitación no pudo ser eliminada. Intente nuevamente',
      invitationNoRejected: 'La invitación no pudo ser rechazada. Intente nuevamente',
      invitationNoUpdated: 'La invitación no pudo ser actualizada. Intente nuevamente'
    }
  }
}